var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSwap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#3C6FF5",
    stroke: "#DCE0E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1082 24.8584L12.579 27.827C12.7705 28.0571 13.1302 28.0578 13.3226 27.8283L15.8906 24.7648C16.1496 24.4558 15.919 23.9924 15.51 24.0001L10.4713 24.0001C10.0718 24.0076 9.85625 24.5557 10.1082 24.8584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8918 15.1416L27.421 12.173C27.2295 11.9429 26.8698 11.9422 26.6774 12.1717L24.1094 15.2352C23.8504 15.5442 24.081 16.0076 24.49 15.9999L29.5287 15.9999C29.9282 15.9924 30.1437 15.4443 29.8918 15.1416Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24V16C13 16 13 13 16.5 13C20 13 20 16 20 16V24C20 24 20 27 23.5 27C27 27 27 24 27 24V16",
    stroke: "white",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSwap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_swap.e98257ed500f338b20b2720c3cc59d88.svg";